import { UserTransaction } from 'api'

export const cacheKeys = {
  myRole: 'myRole',
  myProfile: 'myProfile',
  legalInfo: 'legalInfo',
  imageDetail: (id: string, isAuth: boolean) => ['imageDetail', { id, isAuth }],
  transactionInfo: (uuid: UserTransaction['uuid']) => ['transactionInfo', { uuid }],
}
